import LoaderCover from "./loading";

export default LoaderCover;